"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Label = _interopRequireDefault(require("./components/Label"));
var _Functionality = _interopRequireDefault(require("./Functionality"));
var _NavItem = require("./NavItem.style");
var _menuItems = require("../../../../constants/menuItems");
var _mapIconKeyToUiKit = _interopRequireDefault(require("../../../../utils/mapIconKeyToUiKit"));
var _withLocale = _interopRequireDefault(require("../../../HOCs/withLocale"));
var _SubMenu = _interopRequireDefault(require("../SubMenu"));
const NavItem = props => {
  const {
    locale,
    onNavItemSelected,
    onNavItemDeselected,
    selected,
    subMenu,
    text,
    navItemRef,
    icon,
    subMenuToLeft,
    showAsButton,
    type,
    customRender,
    ModalComp,
    openChangePasswordModal
  } = props;
  const hasSubMenu = subMenu && subMenu.length > 0 || customRender === _menuItems.CUSTOM_DROPDOWN_INTELLIGENCE_PAGES || customRender === _menuItems.CUSTOM_DROPDOWN_COMMODITIES;
  const newIcon = (0, _mapIconKeyToUiKit.default)(icon);
  const id = "navItem-".concat((text || newIcon || type).toLowerCase());
  return /*#__PURE__*/_react.default.createElement(_NavItem.NavItemContainer, {
    key: id
  }, /*#__PURE__*/_react.default.createElement(_Functionality.default, Object.assign({}, props, {
    headerLink: true,
    id: id,
    openChangePasswordModal: openChangePasswordModal
  }), /*#__PURE__*/_react.default.createElement(_Label.default, {
    locale: locale,
    selected: selected,
    text: text,
    newIcon: newIcon,
    hasSubMenu: hasSubMenu,
    id: id,
    showAsButton: showAsButton
  })), /*#__PURE__*/_react.default.createElement(_SubMenu.default, {
    key: "subMenu"
    // @ts-ignore
    ,
    testId: "subMenu-".concat(id)
    // @ts-ignore
    ,
    parentId: "".concat(type, "-").concat(text)
    // @ts-ignore
    ,
    menuItems: subMenu,
    showing: selected && hasSubMenu,
    parentNavItem: navItemRef,
    onNavItemSelected: onNavItemSelected,
    onNavItemDeselected: onNavItemDeselected,
    positionToLeft: subMenuToLeft,
    walkMeId: id,
    customDropdown: customRender,
    ModalComp: ModalComp,
    openChangePasswordModal: openChangePasswordModal
  }));
};
var _default = exports.default = (0, _withLocale.default)(NavItem);